import { render, staticRenderFns } from "./CreateSystem.vue?vue&type=template&id=13276bd5&"
import script from "./CreateSystem.vue?vue&type=script&lang=js&"
export * from "./CreateSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports